import React from 'react';
import { IGatsbyImageData } from 'gatsby-plugin-image';
import Image from 'src/elements/image/image';
import Heading from 'src/elements/typography/heading';
import { Article, ArticleImage, ArticlePreviewDescription, ArticleTitle } from './article.group.styles';

export interface ResourceCenterArticleProps {
  previewDescription?: boolean
  article: {
    slug: string;
    title: string;
    description?: {
      description: string;
    }
    heroImage: { gatsbyImageData: IGatsbyImageData }
  }
}

const ResourceCenterArticle = ({ article, previewDescription = false }: ResourceCenterArticleProps): JSX.Element => {

  return (
    <Article to={`/resources/${article.slug}`} >
      {
        previewDescription && (
          <ArticlePreviewDescription>
            {article.description?.description}
          </ArticlePreviewDescription>
        )
      }
      <ArticleTitle>
        <Heading
          text={article.title}
          size="1.375em"
          sizeSubLg="1.15em"
        />
      </ArticleTitle>
      <ArticleImage>
        <Image childImageSharp={article.heroImage.gatsbyImageData} alt={article.title} />
      </ArticleImage>
    </Article>
  )

}

export default ResourceCenterArticle;
